import {ErrorBoundary as ErrorBoundaryBase} from '@yandex-delivery/modules/rum'
import type {ErrorInfo} from 'react'
import {fetchClearDraftSync} from 'src/shared/api'

export class ErrorBoundary extends ErrorBoundaryBase {
  componentDidCatch(error: Ya.Rum.LoggableError, additional: ErrorInfo) {
    fetchClearDraftSync()
    super.componentDidCatch(error, additional)
  }
}
